<template>
  <b-card>
    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col md="6">
          <b-form-group label-for="kategoriJenisTiketList" label="Kategori Konsultasi">
            <v-select
              disabled
              v-model="optionsLocal.kategori_jenis_tiket_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="kategoriJenisTiketOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="kategori_jenis_tiket"
              @input="val => changeJenisTiket(val)"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label-for="jenisTiketList" label="Jenis Konsultasi">
            <v-select
              disabled
              v-model="optionsLocal.jenis_tiket_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="jenisTiketOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="jenis_tiket"
            />
          </b-form-group>
        </b-col>
        <!--
        <b-col md="6">
          <b-form-group
            label="Tanggal Mulai"
          >
            <flat-pickr
              v-model="optionsLocal.tanggal_mulai"
              class="form-control"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Tanggal Akhir"
          >
            <flat-pickr
              v-model="optionsLocal.tanggal_akhir"
              class="form-control"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Status"
            label-for="account-name"
          >
            <v-select
              id="statusList"
              v-model="optionsLocal.private"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOption"
              item-text="id"
              item-value="label"
              @input="(val) => changePrivate(val)"
            />
          </b-form-group>
        </b-col>
        <b-col md="6"
          v-if="showPassword"
        >
          <b-form-group
            label-for="account-new-password"
            label="Masukan Password"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-new-password"
                v-model="optionsLocal.password"
                :type="passwordFieldTypeNew"
                name="new-password"
                placeholder="Masukan Password Baru"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconNew"
                  class="cursor-pointer"
                  @click="togglePasswordNew"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col> -->
        <!-- deskripsi -->
        <div v-if="divDownload">
          <b-col cols="12">
            <b-form-group label="Download File" label-for="upload-file">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                class="mb-75 mr-75"
                @click="download"
              >
                Download
              </b-button>
            </b-form-group>
          </b-col>
        </div>
        <b-col cols="12">
          <b-form-group label="Judul" label-for="keterangan-area">
            <b-form-input
              readonly
              id="keterangan-area"
              v-model="optionsLocal.keterangan"
              rows="4"
              placeholder="Keterangan disini..."
            />
          </b-form-group>
        </b-col>
        <!-- output -->
        <b-col cols="12">
          <b-form-group label="Detail Permasalahan" label-for="permasalahan-area">
            <b-form-textarea
              readonly
              id="permasalahan-area"
              v-model="optionsLocal.permasalahan"
              rows="4"
              placeholder="Permasalahan selengkapnya disini..."
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" v-if="divTeamViewer">
          <b-form-group label="ID TeamViewer" label-for="id-teamviewer">
            <b-form-input
              disabled
              v-model="optionsLocal.id_teamviewer"
              name="id-teamviewer"
              placeholder="ID TeamViewer"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="divTeamViewer">
          <b-form-group label="Password TeamViewer" label-for="pass-teamviewer">
            <b-form-input
              disabled
              v-model="optionsLocal.password_teamviewer"
              name="pass-teamviewer"
              placeholder="Password TeamViewer"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <!-- <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="simpan"
            v-if="optionsLocal.status_tiket_id === 0"
          >
            Simpan
          </b-button> -->
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            type="reset"
            class="mt-2"
            @click.prevent="resetForm"
          >
            Reset
          </b-button> //-->
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import { getTiket, downloadDokumenTiket } from '@/connection-api/tiket'
import { getKategoriJenisTiket, getJenisTiket, getJenisTiketById } from '@/connection-api/master'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    // flatPickr,
    // BInputGroup,
    // BInputGroupAppend,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      divTeamViewer: false,
      optionsLocal: {
        status_tiket_id: 'e2281ff8-2558-11ee-acb1-3497f616f0',
      },
      date: null,
      localData: [],
      /* eslint-disable global-require */
      avatar: require('@/assets/images/pages/default.png'),
      /* eslint-disable global-require */
      passwordFieldTypeNew: 'password',
      showPassword: false,
      statusOption: [
        {
          id: 0,
          label: 'Publik',
        },
        {
          id: 1,
          label: 'Privat',
        },
      ],
      kategoriJenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Kategori Jenis Konsultasi --' }],
      },
      jenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis Konsultasi --' }],
      },
      divDownload: false,
    }
  },
  computed: {
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  async mounted() {
    if (this.$route.params.id) {
      // const response = await getTiket(this.$route.params.id)
      const params = {}
      // if (this.$can('proses', 'tiket')) {
      //   params = { proses: false }
      // }
      const response = await getTiket(this.$route.params.id, params)
      this.localData = response.data.data
      this.optionsLocal = this.localData
      this.changeJenisTiket(this.optionsLocal.kategori_jenis_tiket_id)
      // console.log('256')
      // console.log(this.optionsLocal)
      // this.optionsLocal.proyek_id = this.localData.proyek_id
      // this.optionsLocal.nama = this.localData.nama
      // this.optionsLocal.lokasi = this.localData.lokasi
      // this.optionsLocal.deskripsi = this.localData.deskripsi
      // this.optionsLocal.output = this.localData.output
      // this.optionsLocal.tanggal_mulai = this.localData.tanggal_mulai
      // this.optionsLocal.tanggal_akhir = this.localData.tanggal_akhir
      // this.optionsLocal.image = `${process.env.VUE_APP_API_URL}/kegiatan/download/${this.localData.img}`
      // this.optionsLocal.img = this.localData.img
      // this.optionsLocal.password = this.localData.password
      // if (!this.localData.private) {
      //   this.optionsLocal.private = {
      //     id: 0,
      //     label: 'Publik',
      //   }
      //   this.showPassword = false
      // } else if (this.localData.private === 1) {
      //   this.optionsLocal.private = {
      //     id: 1,
      //     label: 'Privat',
      //   }
      //   this.showPassword = true
      // } else {
      //   this.optionsLocal.private = {
      //     id: 0,
      //     label: 'Publik',
      //   }
      //   this.showPassword = false
      // }
    }
    try {
      const responseKategoriJenisTiket = await getKategoriJenisTiket()
      this.mappingSelectOption(
        responseKategoriJenisTiket.data,
        this.kategoriJenisTiketOptions.options,
      )
    } catch (error) {
      // console.log(error.response.data)
    }
    // console.log(this.optionsLocal.select_proyek)
  },
  methods: {
    changeJenisTiket(value) {
      this.reloadJenisTiketOptions(value)
      this.divDownload = false
      if (value === '22e54eef-254b-11ee-acb1-3497f616fa2') {
        this.divTeamViewer = true
      }
      // if (this.optionsLocal.jenis_tiket_id === 37 && this.optionsLocal.kategori_jenis_tiket_id === 10) {
      //   this.divDownload = true
      // }
    },
    async reloadJenisTiketOptions(kategoriJenisTiketId) {
      this.jenisTiketOptions = {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis --' }],
      }
      const response = await getJenisTiket({
        kategori_jenis_tiket_id: kategoriJenisTiketId,
        perPage: 100,
        page: 1,
      })
      this.mappingSelectOption(response.data.data, this.jenisTiketOptions.options)
      try {
        const resp = await getJenisTiketById(this.optionsLocal.jenis_tiket_id)
        if (resp.data.data.flg_document === 1) {
          this.divDownload = true
        } else {
          this.divDownload = false
        }
        this.optionsLocal.flg_document = resp.data.data.flg_document
      } catch (error) {
        // console.log('id tidak ada')
      }
      this.optionsLocal.jenis_tiket_id_tr = this.optionsLocal.jenis_tiket_id
    },
    resetForm() {
      this.optionsLocal = []
    },
    simpan() {
      if (this.$route.params.id) {
        this.optionsLocal.tiket_id = this.$route.params.id
      }
      this.localData = this.optionsLocal
      // if (this.optionsLocal.private.id) {
      // this.localData.private = this.optionsLocal.private.id
      // }
      this.$emit('clicked', this.localData)
    },
    onFileChange(e) {
      const file = e.target.files[0]
      this.optionsLocal.img = URL.createObjectURL(file)
      this.optionsLocal.image = this.optionsLocal.img
    },
    async download() {
      this.show = true
      try {
        const resp = await downloadDokumenTiket(this.optionsLocal.file)
        const fileURL = window.URL.createObjectURL(new Blob([resp.data]))
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', this.optionsLocal.file)
        document.body.appendChild(fileLink)
        fileLink.click()
        this.show = false
      } catch (error) {
        this.show = false
        this.makeToast('danger', 'gagal')
      }
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Tiket',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    return {
      refInputEl,
      previewEl,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
